var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textWrap",staticClass:"presentation text",class:{
    hasOption: _vm.question.video || _vm.question.audio,
  },style:({
    justifyContent: _vm.pFlexAlign,
    fontFamily: _vm.pFont,
    height: _vm.textBlockHeight,
  })},[_c('div',{ref:"textBlock",staticClass:"text-block",staticStyle:{"margin":"auto 0","padding":"1em 0"},style:({
      fontSize: (_vm.pFontZoom + "em"),
      textAlign: _vm.pAlign,
    }),domProps:{"innerHTML":_vm._s(_vm.presentation.value.split('\n').join('<br>'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }